import cookie from "../../modules/cookie";

(function () {
    if (document.querySelectorAll(".js-cookie-banner").length > 0) {

        const cookieBanner = {
            init: function () {
                this.getCookie();
                this.setCookie();
            },
            getCookie: () => {
                const cookieBannerEl = document.querySelector(".js-cookie-banner");
                const cookieValue = cookie.getCookie("CookiesAccept");
                const cookieLinkText = document.getElementById("cookie-link-text");

                if (cookieValue.length < 1) {
                    cookieBannerEl.classList.add("cookie__banner--visible");
                    cookieBannerEl.setAttribute("tabindex", "1");
                    cookieLinkText.focus();
                    cookieBanner.addModalEventListeners();
                }
            },
            setCookie: () => {
                const cookieAcceptButton = document.querySelector(".js-cookies-accept");
                const cookieBannerEl = document.querySelector(".js-cookie-banner");
                const cookieExpires = cookieBannerEl.dataset.expires;

                cookieAcceptButton.addEventListener("click", () => {
                    cookie.setCookie("CookiesAccept", 0, cookieExpires);
                    location.reload();
                });
            },
            addModalEventListeners: () => {
                const cookieBannerManageButton = document.querySelector(
                    ".js-cookies-manage"
                );
                const cookieBannerEl = document.querySelector(".js-cookie-banner");
                const cookieExpires = cookieBannerEl.dataset.expires;
                const target = document.querySelector(".js-cookie-modal");
                const targetInner = document.querySelector(".cookie__modal--container");
                const innerModal = document.querySelector(".cookie__modal--inner");

                //Manage click on cookie banner preferences button
                cookieBannerManageButton.addEventListener("click", () => {
                    cookieBannerEl.classList.remove("cookie__banner--visible");
                    targetInner.classList.add("visible");
                    target.classList.add("cookie__modal--visible");
                });

                //Adding event listeners to dynamically created handlebars view
                target.addEventListener("click", (e) => {
                    //Accepting all cookies from cookie modal preferences
                    if (e.target.classList.contains("js-cookie-modal-accept")) {
                        cookie.setCookie("CookiesAccept", 0, cookieExpires);

                        innerModal.classList.add("loading");

                        setTimeout(function () {
                            location.reload();
                        }, 2000);
                    }

                    //Accepting some of the cookies from cookie modal preferences
                    if (e.target.classList.contains("js-cookie-modal-customaccept")) {
                        innerModal.classList.add("loading");
                        cookieBanner.setCookieState();

                        setTimeout(function () {
                            location.reload();
                        }, 2000);
                    }
                });
            },
            setCookieState: () => {
                const cookieBannerEl = document.querySelector(".js-cookie-banner");
                const cookieExpires = cookieBannerEl.dataset.expires;
                const cookiesCheckboxes = document.querySelectorAll(".cookie__checkbox");
                let gaAccept = "gaDecline";

                if (cookiesCheckboxes.length > 0) {
                    cookiesCheckboxes.forEach((cookie) => {
                        if (!cookie.disabled) {
                            const id = cookie.getAttribute("id");

                            // Google Analytics
                            if (id === "_ga--_gat--_gid") {
                                if (cookie.checked) {
                                    gaAccept = "gaAccept";
                                } else {
                                    gaAccept = "gaDecline";
                                }
                            }
                        }
                    });

                    cookie.setCookie("CookiesAccept", gaAccept, cookieExpires);
                }
            },
        };

        cookieBanner.init();
    }
})();
